export const styles = {
  nameContainer: 'tw-flex tw-items-center tw-gap-3',
  avatar: 'tw-w-9 tw-h-9 tw-rounded-full tw-bg-primary-600 tw-flex tw-items-center tw-justify-center tw-text-white tw-font-medium tw-text-sm',
  name: 'tw-font-medium tw-text-neutral-900',
  displayId: 'tw-text-neutral-600',
};
